import DatePicker from "react-datepicker";
// import { Datepicker } from "flowbite-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import {
  FaFacebookF,
  FaLine,
  FaRegCalendarAlt,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { getNewsData } from "../api/home";
import {
  formatThaiDate,
  stringHtmlTags,
  toImagePath,
} from "../utils/globalFunctions";
import { tabs } from "./Home";
import {
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  InstapaperShareButton,
  LineIcon,
  LineShareButton,
  TwitterShareButton,
  XIcon,
} from "react-share";

function News() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get("category");
  const [headerTitle, setHeaderTitle] = useState("");
  const [newsData, setNewsData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const newSelected = useMemo(() => {
    scrollToTop();
    return newsData.find((item) => item._id === id);
  }, [id, newsData]);

  const newsFilter = useMemo(() => {
    const filteredByCategory = newsData.filter((item) => item.category.includes(category)?? []);

    if ( startDate && endDate) {
      // แปลงค่า startDate และ endDate เป็น Date objects
      const start = new Date(startDate);
      const end = new Date(endDate);
  
      return filteredByCategory.filter((item) => {
        // console.log('item',item);

        // แปลง showdate ของ item เป็น Date object
        const itemDate = new Date(item._created * 1000); 
        if (itemDate >= start && itemDate <= end) {
          console.log('itemDate 2', itemDate);
          console.log('start', start);
          console.log('end', end);
          console.log('-------------');
          return true; // เก็บ item นี้ในผลลัพธ์
        }
        return false; // ไม่เก็บ item นี้
  
      });
    }
    return filteredByCategory; // หากไม่มีการเลือกช่วงวันที่ คืนค่าเฉพาะรายการตาม category

  }, [newsData, category, startDate, endDate]);

  useEffect(() => {
    const findLabel = tabs.find((tab) => tab.value === category);

    if (findLabel) {
      setHeaderTitle(findLabel.label);
    } else {
      setSearchParams({ category: "news" });
    }
  }, [category, tabs, setSearchParams]);

  const fetchNews = useCallback(async () => {
    try {
      const res = await getNewsData();

      const filteredData = res.sort((a, b) => b._created - a._created);

      const mapData = filteredData.map((item) => {
        return {
          ...item,
          image: toImagePath(item?.newsimage?.path),
          title: item.title,
          datetime: item._created,
          url: `/news/${item._id}`,
        };
      });
      console.log('mapData',mapData);
      setNewsData(mapData);
    } catch (err) {
      console.warn(err);
    }
  }, []);
  // const [dateRange, setDateRange] = useState({startDate:'',endDate :''});

  const onChange = (dates) => {
    if (Array.isArray(dates)) {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
      // console.log('start',start,'end',end);
    } else {
      console.error("Expected dates to be an array, but got:", dates);
    }
  };

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);
  // useEffect(() => {
  //   console.log("dateRange", startDate, endDate);
  // }, [startDate, endDate]);
  return (
    <main className="site-main">
      <div className="bg-news-intro">
        <img className="" src="/images/hero-image.jpeg" alt="" />
        <div className="headline">
          <h1 className="text-3xl md:text-6xl capitalize">{headerTitle}</h1>
        </div>
      </div>
      <div className="">
        <div
          className={`${
            id !== undefined
              ? "bg-white p-4 md:p-6 rounded-xl drop-shadow-md"
              : ""
          } container mx-auto relative top-[-4rem] z-10`}
        >
          {id === undefined ? (
            <div className="container max-w-[1200px] mx-auto">
              <div className="flex justify-end gap-2 items-center">
                <DatePicker
                  style={{
                    width: "200px",
                  }}
                  selected={startDate}
                  onChange={onChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  dateFormat="dd/MM/yyyy"
                />
                {/* <DateRangePicker  style={{
                    width: "400px",
                  }}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  /> */}

                <BiSolidChevronRightCircle
                  color="red"
                  size={35}
                  onClick={() => navigate("/calendar")}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <div className="flex flex-auto flex-wrap">
                {newsFilter.map((item, index) => (
                  <Link
                    key={index}
                    to={`${item.url}`}
                    className="news-card p-2"
                  >
                    <div className="news-card__image">
                      <img src={item.image} alt="" />
                    </div>
                    <div className="news-card__time text-sm">
                      <FaRegCalendarAlt />
                      <span>{formatThaiDate(item.datetime)}</span>
                    </div>
                    <div className="news-card__desc text-md">
                      {stringHtmlTags(item.content)}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ) : (
            <div className="news-card" style={{ width: "100%" }}>
              <div className="news-card__slug-header text-4xl">
                {newSelected?.title}
              </div>
              <div className="news-card__slug-main">
                <img
                  className="img-aspect-video"
                  src={newSelected?.image}
                  alt=""
                />
                <div className="flex items-center justify-between py-4">
                  <div className="flex items-center text-[#3d3d3d]">
                    <FaRegCalendarAlt className="text-[#3d3d3d]" />
                    <span className="block ml-2">
                      {formatThaiDate(newSelected?.datetime)}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="block">แชร์</span>

                    <FacebookShareButton url={window.location.href}>
                      <FacebookIcon size={32} round={true} />
                    </FacebookShareButton>
                    <LineShareButton
                      url={window.location.href}
                      title={newSelected?.title}
                    >
                      <LineIcon size={32} round />
                    </LineShareButton>

                    <TwitterShareButton
                      url={window.location.href}
                      title={newSelected?.title}
                    >
                      <XIcon size={32} round />
                    </TwitterShareButton>
                  </div>
                </div>
                <div className="text-md text-[#3D3D3D] font-medium">
                  <div
                    dangerouslySetInnerHTML={{ __html: newSelected?.content }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {id !== undefined && (
        <div className="news-card__slug-footer">
          <div className="container mx-auto relative">
            <h5 className="text-2xl text-black font-bold px-4">ข่าวล่าสุด</h5>
            <div className="flex flex-auto flex-wrap">
              {newsData.slice(0, 4).map((item, index) => (
                <Link
                  key={index}
                  to={`/news/${item._id}`}
                  className="news-card p-2"
                >
                  <div className="news-card__image">
                    <img src={item.image} alt="" />
                  </div>
                  <div className="news-card__time text-sm">
                    <FaRegCalendarAlt />
                    <span>{formatThaiDate(item.datetime)}</span>
                  </div>
                  <div className="news-card__desc text-md">
                    {stringHtmlTags(item.content)}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default News;
